import { HOSPITAIS_CURRENT_USER_STORAGE_KEY } from '@/composables/useHospitais/useHospitais'

// Classifica o usuario em um tipo principal para facilitar segmentacao/telemetria.
// Regras validadas com o time de produto:
//   - backoffice tem prioridade sobre todos os outros perfis
//   - secretariaDoMedico = agendamento-medico + role assinarEnviar (único diferenciador do médico)
export function deriveTipoUsuario(roles: string[], pageAuthorized: string[]): string {
  if (
    pageAuthorized.some(p => p.startsWith('backoffice-'))
    || roles.includes('secretariaDoAgendamentoBackoffice')
    || roles.includes('secretariaDoAmbulatorioBackoffice')
  ) return 'backoffice'

  if (pageAuthorized.includes('agendamento-medico')) {
    return roles.includes('assinarEnviar') ? 'secretariaDoMedico' : 'medico'
  }

  if (pageAuthorized.some(p => p.startsWith('financeiro-') || p === 'financeiro')) return 'financeiro'
  if (pageAuthorized.some(p => p.includes('operadora'))) return 'operadora'
  if (pageAuthorized.includes('suporte')) return 'suporte'

  return 'outro'
}

// Traduz deriveTipoUsuario() pro contrato do painel "Sessoes por perfil" do
// dashboard finx-faro-rum. So chama e traduz o resultado (nao duplica a logica
// de classificacao) - deriveTipoUsuario()/GetDemo.ts ficam intocados.
// financeiro/operadora/suporte nao tem valor documentado no painel; por ora
// caem em 'outro' junto com qualquer caso nao mapeado (decisao: nao vale
// distinguir esses por enquanto).
const FARO_PERFIL_MAP: Record<string, 'medico' | 'secretaria' | 'backoffice' | 'outro'> = {
  backoffice: 'backoffice',
  medico: 'medico',
  secretariaDoMedico: 'secretaria',
}

export function deriveFaroPerfil(roles: string[], pageAuthorized: string[]): 'medico' | 'secretaria' | 'backoffice' | 'outro' {
  const tipoUsuario = deriveTipoUsuario(roles, pageAuthorized)
  return FARO_PERFIL_MAP[tipoUsuario] || 'outro'
}

// Le do cache em localStorage (alimentado pelo useHospitais quando alguma tela
// do Agendamento carrega a lista) os ids de hospitais do usuario. So usa o
// cache se ele pertencer ao proprio usuario (sub), cobrindo troca de usuario e
// personificacao. Retorna null se nao houver cache valido.
export function readHospitaisIdsFromStorage(sub: string): string[] | null {
  try {
    const raw = localStorage.getItem(HOSPITAIS_CURRENT_USER_STORAGE_KEY)
    if (!raw) return null
    const cached = JSON.parse(raw)
    if (!cached || cached.sub !== sub || !Array.isArray(cached.ids)) return null
    return cached.ids
  } catch (e) {
    return null
  }
}
